import React, { useMemo } from 'react';

export function ticketQrImageUrl(code, size = 120) {
  const value = String(code || '').trim().toUpperCase();
  if (!value) return '';
  return `https://api.qrserver.com/v1/create-qr-code/?size=${size}x${size}&data=${encodeURIComponent(value)}`;
}

export async function downloadTicketQrPng(code, filename) {
  const value = String(code || '').trim().toUpperCase();
  if (!value) return;
  const url = ticketQrImageUrl(value, 512);
  try {
    const res = await fetch(url);
    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = objectUrl;
    a.download = filename || `${value}-qr.png`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(objectUrl);
  } catch {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}

/**
 * QR code encoding the ticket code for door check-in scanners.
 * Generated on demand from the ticket code — not a separate stored asset.
 */
export default function TicketCodeQr({
  code,
  size = 120,
  className = '',
  title,
  showDownload = false,
}) {
  const url = useMemo(() => ticketQrImageUrl(code, size), [code, size]);
  if (!url) return null;

  const label = title || `QR for ticket ${code}`;
  const safeCode = String(code || '').trim().toUpperCase();

  return (
    <div className="inline-flex flex-col items-center gap-0.5">
      <img
        src={url}
        alt={label}
        title={label}
        width={size}
        height={size}
        className={`bg-white rounded border border-gray-200 ${className}`.trim()}
      />
      {showDownload ? (
        <button
          type="button"
          onClick={() => downloadTicketQrPng(safeCode)}
          className="text-[10px] font-medium text-indigo-700 hover:text-indigo-900 hover:underline"
        >
          Download QR
        </button>
      ) : null}
    </div>
  );
}
